import useTranslation from 'next-translate/useTranslation'
import LoanAmountCard from '@/blocks/CarPawnHero/LoanAmountCard'
import { Button } from '@/components/Button'
import FlowText from './FlowText'

export interface RequestViewProps {
  message: string
  suggestedAmount: number
  /** Slider range from the API (watches 500–100.000 €, bags 250–30.000 €). */
  minAmount: number
  maxAmount: number
  onSubmit: (amount: number) => void
  onReset: () => void
  isSubmitting?: boolean
}

/**
 * No online estimate was possible: the customer picks the amount they would
 * like and sends a request that staff answer with an offer.
 */
export default function RequestView({
  message,
  suggestedAmount,
  minAmount,
  maxAmount,
  onSubmit,
  onReset,
  isSubmitting,
}: RequestViewProps) {
  const { t } = useTranslation('wertCheck')

  return (
    <div className="bg-static-white rounded-xl shadow-[0_0_2rem_rgba(0,0,0,0.1)] p-6 flex flex-col items-center gap-4 text-center">
      <FlowText text={message} className="text-l text-primary" />

      <LoanAmountCard
        className="shadow-none border border-neutral-200 w-full"
        label={t('request_amount_label')}
        ctaText={t('request_cta')}
        initialAmount={suggestedAmount}
        minAmount={minAmount}
        maxAmount={maxAmount}
        onSubmit={onSubmit}
        isSubmitting={isSubmitting}
      />

      <Button type="button" variant="link" onClick={onReset}>
        {t('reset')}
      </Button>
    </div>
  )
}
